import type userCenterZh from '../zh/userCenter';

const userCenter: typeof userCenterZh = {
  tab_profile: 'Profile',
  tab_security: 'Account security',
  tab_orders: 'Orders',
  profile_saved: 'Profile saved',
  password_mismatch: 'The two new passwords do not match',
  password_updated: 'Password updated',
  order_detail_pending: 'Order details (pending integration)',
  basic_info: 'Basic information',
  org_id: 'Organization ID',
  phone: 'Phone number',
  phone_required: 'Please enter a phone number',
  phone_invalid: 'Please enter a valid phone number',
  platform_email: 'Platform email',
  wowbit_assigned: 'Assigned by Wowbit',
  plan_section: 'Current plan',
  addon_section: 'Add-on packages',
  addon_shop: 'Add-on store slots',
  addon_shop_unit: 'slots',
  addon_dm: 'DMs',
  addon_invite: 'Invites',
  addon_mail: 'Emails',
  addon_remain_before: '',
  addon_remain_after: 'left',
  addon_load_failed: 'Failed to load add-on packages',
  current_plan: 'Current plan',
  expire_remain: 'Valid until {{date}} · {{days}} days left',
  go_renew: 'Renew',
  go_upgrade: 'Upgrade now',
  renew_pending: 'Renew (pending integration)',
  shop_slots: 'Store slots',
  shop_total: '{{count}} total',
  shop_used: '{{used}} / {{limit}}',
  addon: 'Add-on',
  addon_shop_pending: 'Add store slots (pending integration)',
  email_quota: 'Email quota',
  unlimited: 'Unlimited',
  email_total: '{{total}} total / month',
  email_used: '{{used}} / {{limit}}',
  addon_email_pending: 'Add email quota (pending integration)',
  save_changes: 'Save changes',
  change_password: 'Change password',
  login_methods: 'Sign-in methods',
  unbind: 'Unbind',
  change: 'Change',
  bind: 'Bind',
  bind_phone_title: 'Bind phone number',
  bind_email_title: 'Bind login email',
  bind_confirm: 'Confirm bind',
  bind_hint: 'A verification code will be sent to this contact. You can sign in with it after binding.',
  bind_success: 'Bound',
  bind_failed: 'Could not bind',
  bind_phone_placeholder: 'Enter a phone number',
  bind_email_placeholder: 'Enter a login email',
  unbind_phone_title: 'Unbind phone number',
  unbind_email_title: 'Unbind login email',
  unbind_confirm: 'Confirm unbind',
  unbind_hint:
    'A verification code will be sent to this contact. After unbinding you cannot sign in with it. Keep at least one other sign-in method.',
  unbind_code_invalid: 'Enter the 6-digit verification code',
  unbind_identity_missing: 'No contact available to unbind',
  unbind_success: 'Unbound',
  unbind_failed: 'Could not unbind',
  unbind_unavailable: 'No contact available to unbind',
  change_phone_title: 'Change phone number',
  change_email_title: 'Change login email',
  change_confirm: 'Confirm change',
  change_hint: 'Request a BINDING code for both the current and new contact before submitting.',
  change_old_identity: 'Current contact',
  change_old_code: 'Code for current contact',
  change_new_identity: 'New contact',
  change_new_code: 'Code for new contact',
  change_phone_placeholder: 'Enter the new phone number',
  change_email_placeholder: 'Enter the new login email',
  change_email_invalid: 'Enter a valid email address',
  change_same_identity: 'New contact must differ from the current one',
  change_success: 'Changed',
  change_failed: 'Could not change contact',
  current_password: 'Current password',
  current_password_required: 'Please enter current password',
  new_password: 'New password',
  new_password_required: 'Please enter a new password',
  password_rule: 'At least 8 characters, no spaces, and no more than 72 UTF-8 bytes',
  current_password_rule: 'Current password must be no more than 72 characters and 72 UTF-8 bytes',
  password_change_failed: 'Failed to change password',
  password_changed_relogin: 'Password updated. Please sign in again',
  strength: 'Password strength: {{level}}',
  strength_weak: 'Weak',
  strength_mid: 'Medium',
  strength_strong: 'Strong',
  confirm_password: 'Confirm new password',
  confirm_password_required: 'Please enter the new password again',
  order_packages: 'Plan orders',
  order_benefits: 'Standalone benefit orders',
  col_order_no: 'Order no.',
  col_package: 'Plan',
  col_amount: 'Amount',
  col_status: 'Status',
  col_purchased_at: 'Purchased at',
  col_actions: 'Actions',
  status_completed: 'Completed',
  status_pending: 'Pending payment',
  status_cancelled: 'Cancelled',
  orders_load_failed: 'Could not load orders',
  fulfillment_PENDING: 'Pending grant',
  fulfillment_FULFILLED: 'Granted',
  fulfillment_MANUAL_REVIEW: 'Needs review',
  order_days: '{{days}} days'
};

export default userCenter;
